import React, { useContext, useState } from "react";
import { Divider, Link, Menu, MenuItem } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { SnackbarContext } from "../../../../context/snackbar";
import { GlobalLoaderContext } from "../../../../context/global-loader";
import { AuthContext } from "../../../../context/auth";
import ApiUri from "../../../../api/api-uri";
import API from "../../../../api/api";
import AddSongIdModal from "./AddSongIdModal";
import { Platform } from "../../../../models/publishing/platform";

const testSite =
  window.location.href.includes("test") ||
  window.location.href.includes("localhost");

const useStyles = makeStyles(() => {
  return {
    menuIcon: {
      "&:hover": {
        cursor: "pointer",
      },
    },
    menuItemIcon: {
      marginRight: 10,
    },
  };
});

interface IContextMenu {
  platform: Platform;
  composition: any;
  setComposition: React.Dispatch<any>;
}

export default function ContextMenuPlatform({
  platform,
  composition,
  setComposition,
}: IContextMenu) {
  const classes = useStyles();
  const [addSongIdModalOpened, setAddSongIdModalOpened] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const { initSnackbarSuccess, initSnackbarError } =
    useContext(SnackbarContext);
  const { startGlobalLoader, stopGlobalLoader } =
    useContext(GlobalLoaderContext);
  const { user, userRole } = useContext(AuthContext);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  return (
    <React.Fragment>
      <MoreVertIcon onClick={handleClick} className={classes.menuIcon} />
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={() => setAddSongIdModalOpened(true)}>
          Add Song ID
        </MenuItem>
      </Menu>
      {addSongIdModalOpened && (
        <AddSongIdModal
          modalOpened={addSongIdModalOpened}
          handleClose={() => setAddSongIdModalOpened(false)}
          platform={platform}
          composition={composition}
          setComposition={setComposition}
        />
      )}
    </React.Fragment>
  );
}
